module.exports = __webpack_public_path__ + "static/img/gxtz.aca8d904.png";